import style from "./MainBlob.module.scss";
import PurpleSVG from "../../../public/main_page/entry_block/purple_blob.svg";
import GreenSVG from "../../../public/main_page/entry_block/green_blob.svg";

function MainBlob({ isBlur = false, isFixed = false, isBack = false }) {
	const purpleClassName = `${style.purpleIcon} ${isBlur ? style.blur : ""} ${isFixed ? style.fixed : ""} ${isBack ? style.forBack : ""}`;
	const greenClassName = `${style.greenIcon} ${isBlur ? style.blur : ""} ${isFixed ? style.fixed : ""} ${isBack ? style.forBack : ""}`;
	return (
		<>
			<PurpleSVG className={purpleClassName} />
			<GreenSVG className={greenClassName} />
		</>
	);
}

export default MainBlob;
